import { createSlice } from '@reduxjs/toolkit';
import type { RequestStatus, GenericError } from '@skynet/data-ws-core';
import { registerErrorMessage, parseResponse } from '@skynet/data-ws-core';
import { describeWsFailure } from 'src/store/utils';
import { addEsDexPair, deleteEsDexPair } from 'src/store/trading/dex/action';
import { DexTradingApiCommands } from 'src/store/trading/dex/types';
import { actionEsOnMessage } from '@skynet/data-ws-es';
import type { UserListItem } from '@skynet/data-users';

registerErrorMessage(DexTradingApiCommands.AddESDEXPair, {
  title: 'Add DEX Pair Error',
  getDescription: describeWsFailure,
});

const allowedCommands = Object.values(DexTradingApiCommands);

export interface initialDexSetupState {
  resAddDexPair: RequestStatus;
  userList: UserListItem[];
  error: null | GenericError;
}

const initialState: initialDexSetupState = {
  resAddDexPair: null,
  error: null,
  userList: [],
};

const dexSetup = createSlice({
  name: `dexSetup`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // on WS message

    builder.addCase(addEsDexPair.pending, (state) => {
      state.resAddDexPair = 'pending';
    });

    builder.addCase(actionEsOnMessage, (state, action) => {
      const { json, skipProcessing, error, errorCommand } = parseResponse(
        action.payload,
        allowedCommands,
      );

      if (skipProcessing || !json) return;

      const { command } = json;

      console.debug(`dexSetup/processing ${actionEsOnMessage.toString()}`, action, allowedCommands);

      if (error) {
        state.error = error;

        switch (errorCommand) {
          case undefined:
          default:
        }

        return;
      }

      if (command === DexTradingApiCommands.AddESDEXPair) {
        state.resAddDexPair = 'success';
      }
    });
  },
});

export const dexEsActions = {
  ...dexSetup.actions,
  addEsDexPair,
  deleteEsDexPair,
};

export default dexSetup.reducer;
